<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div style="margin-top: 6rem !important;">
    <div v-if="showLoading" class="mx-4">
      <custom-skeleton size="large" :count="7" />
    </div>
    <div v-else class="mx-4">
      <div v-for="(course, index) in modules.map(function(item) {return item.courseName }).filter(function(value, index, self) {return self.indexOf(value) === index})" :key="index" class="mb-4">
        <vs-divider><h4>{{ course }}</h4></vs-divider>

        <div v-for="(mod, modIndex) in modules.filter(function(item){return item.courseName == course})" :key="modIndex" class="mb-3">
          <div style="border-radius: 30px; background-color: rgba(0,0,0,0.5);" class="mb-3 green-border border-3px cursor-pointer" @click.stop="moduleSelected(mod)" :class="false ? 'disabled':''">
            <div class="vx-row" style="padding: 1.5rem">
              <div class="vx-col w-full" style="padding-left: 1rem; padding-right: 1rem;">
                <div class="vx-row">
                  <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                    <feather-icon icon="CodesandboxIcon" class="text-white" svg-classes="stroke-current h-12 w-12"></feather-icon>
                  </div>
                  <div class="vx-col w-3/5 text-left" style="padding-left: 1.3rem; padding-right: 0;">
                    <div class="vx-row">
                      <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                        <p class="mb-1 font-brightgreen" style="font-size: 2.1rem;font-weight: 600;letter-spacing: -2px;line-height: 1.2;">{{mod.moduleName}}</p>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                        <h5>{{mod.moduleDescription}}</h5>
                      </div>
                    </div>
                  </div>
                  <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                    <custom-svg variant="arrow" width="60" height="60" color="white" dir="right" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSvg from '@/gen-2/components/CustomSVG.vue';
export default {
  components: {
    CustomSvg
  },
  data() {
    return {
      showLoading: false,
      modules: []
    };
  },
  computed: {
    
  },
  methods: {
    getStudentMentorModules() {
      var self = this;
      self.showLoading = true;
      var onSuccess = function (response) {
        self.modules = response.data;
      };
      var onFinally = function () {
        self.showLoading = false;
      };

      self.$ajaxGet(self, "MentorModule/GetMentorModuleForStudent", onSuccess, onFinally);
    },
    moduleSelected(mod) {
      this.$router.push({ name: "Gen2Mentoring", query: { module: mod.moduleId, n: mod.moduleName } });
    },
  },
  mounted() {
    var self = this;
    
    self.getStudentMentorModules();
  },
  created() {
    window.scrollTo(0,0);
  }
};
</script>